import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={18}
    height={30}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.682 2.682 15 0 0 15l15 15 2.682-2.682L5.364 15 17.682 2.682Z"
      fill="#666"
    />
  </svg>
);

export default SvgComponent;
